import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { RenderPropSticky } from 'react-sticky-el'
import VULogoMelbourneBlackDiamond from '../../static/img/logos/vu_logo_melb_black_diamond.svg'
import VULogoMelbourneWhiteDiamond from '../../static/img/logos/vu_logo_melb_white_diamond.svg'
import VULogoPolyBlackDiamond from '../../static/img/logos/vu_logo_poly_black_diamond.svg'
import VULogoPolyWhiteDiamond from '../../static/img/logos/vu_logo_poly_white_diamond.svg'
import VULogoDiamondBlack from '../../static/img/logos/vu_logo_diamond_black.svg'
import VULogoDiamondWhite from '../../static/img/logos/vu_logo_diamond_white.svg'
import MyVULogoImageBlack from '../../static/img/myvu-logo-black.svg'
import MyVULogoImageWhite from '../../static/img/myvu-logo-white.svg'
import { Menu } from '@mui/icons-material';
import { getPersonalDetails, getReferences } from '../../services/vu'
import { getProperty } from '../../helpers/properties'
import { connect } from 'react-redux'
import { getIconsByCohort } from '../../services/reservoir'
import { selectDefaultSlide } from '../../actions/sliders'
import AddressType from '../../enums/AddressType'
import StickyHeaderUserInfo from './StickyHeaderUserInfo'
import { getConfiguration } from '../../helpers/configuration'

const VUMelbourneLogo = (props) => <img className="vu-logo" alt="Victoria University logo" src={props.isFixed ? VULogoMelbourneBlackDiamond : VULogoMelbourneWhiteDiamond} />

const VULogoMobile = () => <img className="vu-diamond" alt="Victoria University logo" src={VULogoDiamondBlack} />

const VUPolyLogo = (props) => <img className="vu-logo" alt="Victoria Polytechnic logo" src={props.isFixed ? VULogoPolyBlackDiamond : VULogoPolyWhiteDiamond} />

const VUPolyMobile = (props) => <img className="vu-diamond" alt="Victoria Polytechnic logo" src={props.isFixed ? VULogoDiamondBlack : VULogoDiamondWhite} />

const MyVULogo = (props) => <img className="myvu-logo" alt="MuVU logo" src={props.isFixed ? MyVULogoImageBlack : MyVULogoImageWhite} />

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse } }) => {
  return {
    courseId: selectedCourseCode,
    admissionCategory: selectedCourse.admissionCategory,
    stdCommencingStatus: selectedCourse.stdCommencingStatus
  }
}

const mapDispatchToProps = dispatch => {
  return {
    switchDefaultSlide: courseId => {
      dispatch(selectDefaultSlide(courseId))
    }
  }
}

class StickyHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      preferredName: '',
      logo: 'Victoria University'
    }
  }

  componentDidMount() {
    this.initialiseLogo()

    getPersonalDetails().then(personalDetails => {
      const preferredName = personalDetails.preferredName
      const firstName = personalDetails.chosenFirstName || personalDetails.legalFirstName

      this.setState({
        preferredName: preferredName || firstName
      })

      getReferences().then(({ countryCodesList = [] }) => {
        const studentAddress = this.getStudentAddress(personalDetails.address)

        const getStudentCountry = () => {
          if (studentAddress) {
            switch (studentAddress.addressType) {
              case AddressType.HomeDom:
              case AddressType.Postal:
              case AddressType.SemDom:
                return 'Australia'
              case AddressType.HomeInt:
              case AddressType.OsPostal:
              case AddressType.SemInt:
                const country = countryCodesList.find(({ countryCode }) => countryCode === studentAddress.country)
                if (country) {
                  return country.description
                }
                return undefined
              default:
                return undefined
            }
          }

          return undefined
        }

        window.dataLayer.push({
          event: 'custom.service.user',
          content: {
            environment: getProperty('environment'),
            uiExperience: undefined
          },
          geo: {
            postcode: studentAddress && studentAddress.postCode,
            state: studentAddress && studentAddress.state,
            country: getStudentCountry()
          },
          // Probably best to leave this all undefined!
          user: {
            emailHash: undefined,
            id: undefined,
            sessionId: undefined,
            sessionStart: undefined,
            type: 'Student'
          },
          data: {
            courseId: this.props.courseId,
            applicationModel: undefined,
            commencingStatus: this.props.stdCommencingStatus,
            cohort: this.props.admissionCategory
          },
          processId: undefined
        })
      })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.admissionCategory !== this.props.admissionCategory) {
      this.initialiseLogo()
    }
  }

  getStudentAddress = (addressses = []) => {
    const residentialAddress = addressses.find(address => {
      return address.addressType === AddressType.SemDom || address.addressType === AddressType.SemInt
    })

    if (residentialAddress) {
      return residentialAddress
    }

    const permanentAddress = addressses.find(address => {
      return address.addressType === AddressType.HomeDom || address.addressType === AddressType.HomeInt
    })

    if (permanentAddress) {
      return permanentAddress
    }

    const postalAddress = addressses.find(address => {
      return address.addressType === AddressType.Postal || address.addressType === AddressType.OsPostal
    })

    if (postalAddress) {
      return postalAddress
    }

    return null
  }

  initialiseLogo = () => {
    getIconsByCohort(this.props.admissionCategory).then((icons = []) => {
      if (icons.length > 0) {
        const {
          attributes: { field_icon }
        } = icons[0]

        this.setState({
          logo: field_icon
        })
      }
    })
  }

  getLogo = isFixed => {
    switch (this.state.logo) {
      case 'Victoria Polytechnic':
        return (
          <div className="logo-brand">
            <VUPolyLogo isFixed={isFixed} />
            <VUPolyMobile isFixed={isFixed} />
          </div>
        )
      case 'Victoria University':
      default:
        return (
          <div className="logo-brand">
            <VUMelbourneLogo isFixed={isFixed} />
            <VULogoMobile />
          </div>
        )
    }
  }

  getHomeLink = () => {
    return getConfiguration('baseUrl')
  }

  handleGoHome = () => {
    this.props.switchDefaultSlide(this.props.courseId)
  }

  handleHamburgerIconClick = () => {
    window.dataLayer.push({
      event: 'custom.menu.open',
      label: 'Open',
      group: 'Hamburger Menu',
      location: 'Header'
    })

    this.props.onHamburgerClick()
  }

  render() {
    return (
      <RenderPropSticky>
        {({ isFixed, wrapperStyles, wrapperRef, holderStyles, holderRef}) => (
          <div ref={holderRef} style={holderStyles}>
            <div className={`header__sticky ${isFixed? 'sticky': ''}`} ref={wrapperRef} style={wrapperStyles}>
              <div className="container-fluid">
                <div className="row between-xs">
                  <div className="logos">
                    <button className="header-button header-button--hamburger" onClick={this.handleHamburgerIconClick}>
                      <Menu className="btn-point-events" />
                      <span className="sr-only">Open Sidebar</span>
                    </button>

                    {this.getLogo(isFixed)}
                  
                    <Link to={this.getHomeLink()} onClick={this.handleGoHome}>
                      <MyVULogo isFixed={isFixed} />
                    </Link>
                  
                  </div>

                  <StickyHeaderUserInfo preferredName={this.state.preferredName} />
                </div>
              </div>
            </div>
          </div>
        )}
        
      </RenderPropSticky>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StickyHeader)
)
